export default __webpack_public_path__ + "static/media/Img200.23183f58.jpg";